import { Card, CardContent, CardProps, Stack, Typography, useTheme } from '@mui/material';

import VectorImage from '~components/media/vectorImage';
import { StatusVariant } from '~enums';
import {
	getNotificationCardIcon,
	getStatusIconColor,
	getButtonBorderColor,
	getNotificationBackgroundColor,
} from '~enums/statusVariant';
import { Dimens } from '~themes';

interface Props extends CardProps {
	statusVariant: StatusVariant;
	title?: string;
	caption?: string;
	children?: React.ReactNode;
}

const NotificationCard = ({
	statusVariant = StatusVariant.Neutral,
	title,
	caption,
	children,
	...props
}: Props) => {
	const { palette } = useTheme();
	const backgroundColor = getNotificationBackgroundColor(statusVariant, palette);
	const borderColor = getButtonBorderColor(statusVariant, palette);
	const iconName = getNotificationCardIcon(statusVariant);
	const iconColor =
		statusVariant == StatusVariant.Warning ? getStatusIconColor(statusVariant, palette) : 'white';
	return (
		<Card
			sx={{
				backgroundColor: backgroundColor,
				borderColor: borderColor,
				borderWidth: 1,
				borderStyle: 'solid',
				borderRadius: Dimens.radiusMd,
				boxShadow: 'none',
				padding: {
					xs: Dimens.spacingSm,
					md: Dimens.spacingMd,
				},
			}}
			{...props}
		>
			{(title || caption) && (
				<Stack direction='row' spacing={Dimens.spacingXs} alignItems='flex-start'>
					<VectorImage name={iconName} size={Dimens.spacingXl} color={iconColor} />
					<Stack direction='column' spacing={Dimens.spacing2xs} sx={{ flex: 1 }}>
						<Typography variant='label' color={palette.textPrimary.main}>
							{title}
						</Typography>
						<Typography variant='paragraphSm' color={palette.textQuaternary.main}>
							{caption}
						</Typography>
					</Stack>
				</Stack>
			)}
			{children && <CardContent sx={{ height: '100%', padding: 0 }}>{children}</CardContent>}
		</Card>
	);
};

export default NotificationCard;
